module.exports = __webpack_public_path__ + "img/border-3.365900f4.svg";